import CityDetailPage from './CityDetailPage';

export default CityDetailPage;
